import { css } from '@emotion/css';
import { theme } from 'Shared/backend/ThemeProvider';
import { Show,For } from 'solid-js';

const breadcrumbsStyle = () => css({
	userSelect: 'none'
});


export function Breadcrumbs(P:{items})
{
//BUG if any of the labels are parsable as integers then they will appear out of order
//    Probably the most convenient solution would be to use arrays of arrays, eg:
//    	[['Events','/admin/events'], [222: null]]

	return (
		<div class={breadcrumbsStyle()}>
			<For each={Object.entries(P.items)}>{(entry,i) => <>
				<Show when={entry[1]} fallback={entry[0]}>
					<a class={css(theme().a)} href={entry[1]}>{entry[0]}</a> 
				</Show>

				<Show when={ i() < Object.keys(P.items).length - 1 }>
					{' > '}
				</Show>
			</>}</For>
		</div>
	);
}

